import { dynamicImport } from '@core/helpers'
import { ROUTES } from '@router'

// This will be behind a FF until December
// FF_MODELS_COMPARISON_MULTIPLE_CATEGORIES_OPENED
// const homeRoute = {
//   name: ROUTES.MODELS_COMPARISON.HOME,
//   path: 'compare/categories',
//   component: Home,
// }

const ModelsComparison = () => dynamicImport(import('./ModelsComparison.vue'))

export default ({ config, country }) => {
  const isNewModelsComparisonActiveInCountry =
    config.FF_NEW_MODELS_COMPARISON_ACTIVE_IN_COUNTRY?.includes(country)

  return isNewModelsComparisonActiveInCountry
    ? [
        {
          name: ROUTES.MODELS_COMPARISON.HOME,
          path: 'compare',
          component: ModelsComparison,
        },
        {
          name: ROUTES.MODELS_COMPARISON.CATEGORY,
          path: 'compare/:category(smartphones|tablets)',
          component: ModelsComparison,
        },
        {
          name: ROUTES.MODELS_COMPARISON.COMPARISON_RESULTS,
          path: 'compare/:productA/:productB',
          component: ModelsComparison,
        },
      ]
    : []
}
